import auth from '@groovepages/gd-lib/auth';
let user = auth.authenticatedUser();
let region = user?.metadata?.region;
export const userRegion = region;
